var render, staticRenderFns
import script from "./TournamentSelect.vue?vue&type=script&lang=tsx"
export * from "./TournamentSelect.vue?vue&type=script&lang=tsx"
import style0 from "./TournamentSelect.vue?vue&type=style&index=0&id=019c4dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c4dfa",
  null
  
)

export default component.exports